module.exports = __webpack_public_path__ + "img/1.2.26b6b542.jpeg";